import html from './html';
import react from './react';
import vue from './vue';
import angular from './angular';
import nextjs from './nextjs';
import gtm from './gtm';
import wordpress from './wordpress';

// Ordered list of install targets shown as tabs in InstallCodeDialog.
// Each module implements { key, lang, generate({ baseUrl, websiteToken, webWidgetScript }) }.
// Tab labels and instruction copy live in i18n under
// INBOX_MGMT.INSTALL_KIT.TARGETS.<KEY_UPPERCASE>.
export const INSTALLATION_TARGETS = [
  html,
  react,
  vue,
  angular,
  nextjs,
  gtm,
  wordpress,
];
